/*
 * Copyright (c) 2020 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

/**
 * The AlarmBadge component
 *
 * @author Thais Watanabe
 */
const AlarmBadge = (props) => {
  var badgeStyle = "";
  if (props.color === "良好") {
    badgeStyle = "bg-green-100 text-green-800";
  } else {
    badgeStyle = "bg-yellow-100 text-yellow-800";
  }
  return (
    <span
      className={`${badgeStyle} inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium`}
    >
      {props.children}
    </span>
  );
};

export default AlarmBadge;